import { render } from "./modal-target.vue?vue&type=template&id=3614db50"
import script from "./modal-target.vue?vue&type=script&lang=js"
export * from "./modal-target.vue?vue&type=script&lang=js"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__